import { ApiTokensPage } from "~/pages/space-settings/api-tokens/settings-api-tokens";
import { useOrgSettingsOutletContext } from "./settings";

export function ApiTokens() {
  const { org } = useOrgSettingsOutletContext();

  return <ApiTokensPage {...{ org }} />;
}
